import { useEffect } from 'react';
import { FullLogo } from '@rsos/components/capstone/Layout/Navigation/common/logo/RapidSOSLogo';
import { Box } from '@rsos/components/capstone/base';
import { useFlag } from '@rsos/flags';
import NewLogin from '../Auth/Login/NewLogin';
import RebrandedFooter from './RebrandedFooter';
import styles from './RebrandedLanding.module.css';

const REBRAND_BLOG_URL = 'https://rapidsos.com/blog/meet-the-safety-network/';
const REBRAND_FALLBACK_URL = 'https://rapidsos.com/';

// Rebranded login experience, mirroring the b2b_hub LogInPage split layout: a
// marketing column alongside the login card on a white background. Gated by the
// `rebranded_logo` flag from the parent Landing component.
const RebrandedLanding = () => {
  const useRebrandBlogUrl = useFlag('rebrand_blog_url');
  const rebrandNoteUrl = useRebrandBlogUrl
    ? REBRAND_BLOG_URL
    : REBRAND_FALLBACK_URL;

  useEffect(() => {
    document.body.classList.add('rebrandedLandingActive');
    return () => document.body.classList.remove('rebrandedLandingActive');
  }, []);

  return (
    <Box style={{ background: '#ffffff' }} align="center">
      <Box
        horizontal
        align="center"
        maxWidth={1800}
        minHeight="100vh"
        justify="space-evenly"
        width="100%"
        flexWrap="wrap"
        p={16}
        style={{ gap: '140px', minHeight: '100vh' }}
      >
        <Box
          style={{ maxWidth: 765, height: 580 }}
          justify="space-between"
          alignSelf="center"
        >
          <Box style={{ marginBottom: 24 }}>
            <FullLogo height={40} />
          </Box>
          <Box justify="space-between" maxWidth={490} height={280}>
            <h2
              style={{
                fontSize: 16,
                fontStyle: 'normal',
                fontWeight: 'bold',
                lineHeight: '160%',
                margin: 0,
                color: '#000000',
              }}
            >
              RapidSOS Unite
            </h2>
            <h1
              style={{
                fontSize: 36,
                fontStyle: 'normal',
                fontWeight: 'semibold',
                lineHeight: '110%',
                margin: '10px 0',
                textAlign: 'left',
                color: '#000000',
              }}
            >
              You’re connecting to the Safety Network.
            </h1>
            <p
              style={{
                fontSize: 16,
                fontStyle: 'normal',
                fontWeight: 'regular',
                lineHeight: '160%',
                maxWidth: 500,
                margin: 0,
                color: '#000000',
              }}
            >
              RapidSOS connects your agency to 723M+ devices, 250+ enterprises,
              and 23,500+ agencies, so every responder has the full picture
              before they arrive.
            </p>
            <a
              className={styles.rebrandNote}
              href={rebrandNoteUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Same trusted partner. New look. Learn why &gt;
            </a>
          </Box>
          <div />
        </Box>
        <NewLogin />
      </Box>
      <RebrandedFooter />
    </Box>
  );
};

export default RebrandedLanding;
